module.exports = __webpack_public_path__ + "static/media/logo_deca_hu.f28d9dd8.png";